import { Component } from '@angular/core';

@Component({
  selector: 'rr-tab',
  standalone: false,

  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class TabComponent {

}
